import Vue from 'vue';
import Vuex from 'vuex';
import authFlow from '@/modules/authFlow';
import api from '@/api';
import router from '@/router';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: '',
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    },
  },
  actions: {
    async auth() {
      return await authFlow.checkForAuthorizationResponse().then(() => {
        if (!authFlow.isAuthorizationComplete) {
          if (!authFlow.isAccessTokenPresent()) {
            return authFlow.fetchServiceConfiguration().then(() => authFlow.authorize());
          } else {
            if (!authFlow.isAccessTokenValid()) {
              return authFlow.fetchServiceConfiguration().then(() => authFlow.refreshAccessToken());
            }
          }
        } else {
          if (!authFlow.isAccessTokenPresent()) {
            router.push('/');
            return authFlow.fetchServiceConfiguration().then(() => authFlow.getAccessToken());
          }
        }
      });
    },
    setToken({commit}, token) {
      commit('SET_TOKEN', token);
      api.defaults.headers.TokenOauth2 = token;
    },
    // eslint-disable-next-line no-empty-pattern
    async searchEmployee({}, name) {
      return await api
        .post('/', {
          modelName: 'Common',
          calledMethod: 'findStaffsDataByDescription',
          methodProperties: {
            FindByString: name,
            Limit: 5,
            Page: 1,
          },
        })
        .then(res => {
          return res.data.data;
        });
    },
    // eslint-disable-next-line no-empty-pattern
    async voteEmployee({}, employee) {
      return await api
        .post('/', {
          modelName: 'CommonGeneral',
          calledMethod: 'voteForColleague',
          methodProperties: {
            Ref: employee.Ref,
            FullName: employee.Description,
            PostsDescription: employee.PostsDescription,
            StructureDescription: employee.StructureDescription,
            Phone: employee.Phone,
            EMail: employee.EMail,
            Score_Professional: employee.Score_Professional,
            Score_TeamPlayer: employee.Score_TeamPlayer,
            Score_SuperService: employee.Score_SuperService,
            City: employee.City,
            RegionArea: employee.RegionArea,
          },
        })
        .then(res => {
          return res.data.data;
        });
    },
    async getList() {
      return await api
        .post('/', {
          modelName: 'CommonGeneral',
          calledMethod: 'getVotingList',
          methodProperties: {
            FindByString: '',
          },
        })
        .then(res => {
          return res?.data?.data;
        });
    },
  },
  modules: {},
});
